import { render } from "./BaseButtonGetPremium.vue?vue&type=template&id=d90bf394"
import script from "./BaseButtonGetPremium.vue?vue&type=script&lang=js"
export * from "./BaseButtonGetPremium.vue?vue&type=script&lang=js"
script.render = render

export default script